module.exports = __webpack_public_path__ + "static/media/ESG_Frameworks.47871925.svg";